import { Code2, Palette, Boxes, Wrench } from "lucide-react";
import { useState } from "react";

interface TechItem {
  icon: React.ReactNode;
  name: string;
  description: string;
  color: string;
}

const techItems: TechItem[] = [
  {
    icon: <Code2 className="w-8 h-8" />,
    name: "Unity Engine",
    description: "Основной движок для разработки 2D и 3D игр",
    color: "primary",
  },
  {
    icon: <Palette className="w-8 h-8" />,
    name: "Собственные ассеты",
    description: "Уникальные спрайты, текстуры и модели",
    color: "accent",
  },
  {
    icon: <Boxes className="w-8 h-8" />,
    name: "2D & 3D миры",
    description: "Создание многомерных игровых вселенных",
    color: "secondary",
  },
  {
    icon: <Wrench className="w-8 h-8" />,
    name: "Кастомные инструменты",
    description: "Разработка собственных редакторов и систем",
    color: "primary",
  },
];

const TechStack = () => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null);

  return (
    <div className="cyber-card p-8 bg-background/50">
      <p className="text-accent font-bold mb-6 text-lg font-mono">{'>> ТЕХНОЛОГИЧЕСКИЙ_СТЕК'}</p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {techItems.map((item, index) => (
          <div
            key={index}
            className={`cyber-card p-6 cursor-pointer transition-all duration-300 ${
              activeIndex === index
                ? `border-${item.color} shadow-lg shadow-${item.color}/20 scale-105`
                : "hover:border-muted hover:scale-102"
            }`}
            onMouseEnter={() => setActiveIndex(index)}
            onMouseLeave={() => setActiveIndex(null)}
          >
            <div className="flex items-start gap-4">
              <div className={`p-3 rounded-sm border border-${item.color}/40 bg-${item.color}/10 transition-all duration-300 ${
                activeIndex === index ? "scale-110 rotate-6" : ""
              }`}>
                <div className={`text-${item.color}`}>{item.icon}</div>
              </div>
              <div className="flex-1">
                <h4 className={`font-cyber text-lg mb-2 text-${item.color}`}>{item.name}</h4>
                <p className={`text-sm font-mono text-foreground/70 transition-all duration-300 ${
                  activeIndex === index ? "text-foreground" : ""
                }`}>
                  {item.description}
                </p>
              </div>
            </div>
            <div className={`mt-4 h-1 bg-gradient-to-r from-transparent via-${item.color}/50 to-transparent transform transition-all duration-300 ${
              activeIndex === index ? "scale-x-100" : "scale-x-0"
            }`}></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TechStack;
